/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `RepeatingCalendarEventDefinition.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { RepeatingCalendarEventDefinition } from "./RepeatingCalendarEventDefinition";

import { CalendarEvent } from "./CalendarEvent";
import { CalendarEventResource } from "./CalendarEventResource";
import { Project } from "./Project";

export type calendarEventType = "unavailability" | "availability";

export const calendarEventTypeValues = { unavailability: 0, availability: 1 };

export abstract class RepeatingCalendarEventDefinitionModel {
    id: number;
    calendarEventType: calendarEventType;
    createdAt: Dayjs;
    description: string | null;
    duration: number;
    name: string;
    projectId: number;
    rrule: string;
    scheduleEnd: Dayjs | null;
    scheduleStart: Dayjs | null;
    startAt: Dayjs | null;
    updatedAt: Dayjs;
    calendarEventResources: CalendarEventResource[] | undefined;
    calendarEvents: CalendarEvent[] | undefined;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        calendarEventType: calendarEventType,
        createdAt: Dayjs,
        description: string | null,
        duration: number,
        name: string,
        projectId: number,
        rrule: string,
        scheduleEnd: Dayjs | null,
        scheduleStart: Dayjs | null,
        startAt: Dayjs | null,
        updatedAt: Dayjs,
        calendarEventResources: CalendarEventResource[] | undefined,
        calendarEvents: CalendarEvent[] | undefined,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.calendarEventType = calendarEventType;
        this.createdAt = createdAt;
        this.description = description;
        this.duration = duration;
        this.name = name;
        this.projectId = projectId;
        this.rrule = rrule;
        this.scheduleEnd = scheduleEnd;
        this.scheduleStart = scheduleStart;
        this.startAt = startAt;
        this.updatedAt = updatedAt;
        this.calendarEventResources = calendarEventResources;
        this.calendarEvents = calendarEvents;
        this.project = project;
    }

    static fromApiObject(json: any, timezone: string): RepeatingCalendarEventDefinition {
        const newObject = new RepeatingCalendarEventDefinition(
            json["id"],
            json["calendar_event_type"],
            dayjs(json["created_at"]).tz(timezone),
            json["description"],
            json["duration"],
            json["name"],
            json["project_id"],
            json["rrule"],
            json["schedule_end"] ? dayjs(json["schedule_end"]).tz(timezone) : null,
            json["schedule_start"] ? dayjs(json["schedule_start"]).tz(timezone) : null,
            json["start_at"] ? dayjs(json["start_at"]).tz(timezone) : null,
            dayjs(json["updated_at"]).tz(timezone),
            json["calendar_event_resources"]?.map((item: any) => CalendarEventResource.fromApiObject(item, timezone)),
            json["calendar_events"]?.map((item: any) => CalendarEvent.fromApiObject(item, timezone)),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            calendar_event_type: this.calendarEventType,
            created_at: this.createdAt,
            description: this.description,
            duration: this.duration,
            name: this.name,
            project_id: this.projectId,
            rrule: this.rrule,
            schedule_end: this.scheduleEnd,
            schedule_start: this.scheduleStart,
            start_at: this.startAt,
            updated_at: this.updatedAt,
            calendar_event_resources_attributes: this.calendarEventResources?.map((item) => item.toApiObject()),
            calendar_events: this.calendarEvents?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): RepeatingCalendarEventDefinition {
        const clone = Object.create(this) as RepeatingCalendarEventDefinition;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
